import { render, staticRenderFns } from "./tabTargetInfo.vue?vue&type=template&id=fb0d27f4&scoped=true"
import script from "./tabTargetInfo.vue?vue&type=script&lang=js"
export * from "./tabTargetInfo.vue?vue&type=script&lang=js"
import style0 from "./tabTargetInfo.vue?vue&type=style&index=0&id=fb0d27f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0d27f4",
  null
  
)

export default component.exports